import { Navigate, Route, Routes } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import { PublicRoutesConfig, CommonRoutesConfig } from "./RoutesConfig";
import Logout from "./pages/Logout";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Home from "./pages/Home";

import PreviewAuthorization from "./pages/authorizations/Preview";
import HistoryPreviewAuthorization from "./pages/authorizations/HistoryPreview";
import SearchAuthorizations from "./pages/authorizations/Search";

import Help from "./pages/Help";

import PreviewWithdrawnAuthorization from "./pages/withdrawnAuthorizations/Preview";
import HistoryPreviewWithdrawnAuthorization from "./pages/withdrawnAuthorizations/HistoryPreview";
import SearchWithdrawnAuthorizations from "./pages/withdrawnAuthorizations/Search";

import NotFound from "../common/components/pages/NotFound";
import Forbidden from "../common/components/pages/Forbidden";

export default function RoutesTree() {
  const publicRoutes = (
    <>
      <Route
        path={PublicRoutesConfig.Profile.Path}
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Home.Path}
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Authorization.Preview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Authorization}
            permissionType={PublicRoutesConfig.Authorization.Preview.Permission}
          >
            <PreviewAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Authorization.HistoryPreview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Authorization}
            permissionType={PublicRoutesConfig.Authorization.HistoryPreview.Permission}
          >
            <HistoryPreviewAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.Authorization.Search.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.Authorization}
            permissionType={PublicRoutesConfig.Authorization.Search.Permission}
          >
            <SearchAuthorizations />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.WithdrawnAuthorization.Preview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.WithdrawnAuthorization}
            permissionType={PublicRoutesConfig.WithdrawnAuthorization.Preview.Permission}
          >
            <PreviewWithdrawnAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.WithdrawnAuthorization.HistoryPreview.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.WithdrawnAuthorization}
            permissionType={PublicRoutesConfig.WithdrawnAuthorization.HistoryPreview.Permission}
          >
            <HistoryPreviewWithdrawnAuthorization />
          </ProtectedRoute>
        }
      />
      <Route
        path={PublicRoutesConfig.WithdrawnAuthorization.Search.Path}
        element={
          <ProtectedRoute
            register={PublicRoutesConfig.WithdrawnAuthorization}
            permissionType={PublicRoutesConfig.WithdrawnAuthorization.Search.Permission}
          >
            <SearchWithdrawnAuthorizations />
          </ProtectedRoute>
        }
      />
    </>
  );

  return (
    <Routes>
      {/* common routes */}
      <Route path={CommonRoutesConfig.Login.Path} element={<Login />} />
      <Route path={CommonRoutesConfig.LoginRoute.Path} element={<Login />} />
      <Route
        path={CommonRoutesConfig.Logout.Path}
        element={
          <ProtectedRoute>
            <Logout />
          </ProtectedRoute>
        }
      />
      <Route path={CommonRoutesConfig.Help.Path} element={<Help />} />
      <Route path={CommonRoutesConfig.Forbidden.Path} element={<Forbidden />} />
      <Route path={CommonRoutesConfig.NotFound.Path} element={<NotFound />} />
      <Route path={CommonRoutesConfig.SSL.Path} element={<Navigate to={CommonRoutesConfig.Login.Path} />} />

      {publicRoutes}
    </Routes>
  );
}
